module.exports = __webpack_public_path__ + "img/defaultIcon.725c173f.png";